import { render, staticRenderFns } from "./ContentButton.vue?vue&type=template&id=4b3a44c5"
import script from "./ContentButton.vue?vue&type=script&lang=js"
export * from "./ContentButton.vue?vue&type=script&lang=js"
import style0 from "./ContentButton.vue?vue&type=style&index=0&id=4b3a44c5&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports